import React from 'react';
import { Platform, StyleProp, StyleSheet, Text, View, ViewStyle } from 'react-native';
import { useRouter } from 'expo-router';
import Button from '../ui/Button';
import colors from '../../lib/colors';
import { interRegular } from '../../lib/fonts';
import { buildBillingPreviewTrialHref } from '../../lib/billingPreviewState';
import { Trans } from '@lingui/react/macro';
import { msg } from '@lingui/core/macro';
import type { LocalizedMessage } from '../../lib/i18n/messages';

interface PreviewResumeTrackingButtonProps {
    previewProjectId?: string | null;
    resultDigestId?: string | null;
    trialHref?: string | null;
    style?: StyleProp<ViewStyle>;
    testID?: string;
    label?: LocalizedMessage;
}

export default function PreviewResumeTrackingButton({
    previewProjectId,
    resultDigestId,
    trialHref: authoritativeTrialHref,
    style,
    testID = 'preview-resume-tracking-button',
    label = msg({ id: 'preview.resumeTrackingTrial', message: 'Resume tracking with a free trial' }),
}: PreviewResumeTrackingButtonProps) {
    const router = useRouter();
    const trialHref = authoritativeTrialHref || buildBillingPreviewTrialHref({
        projectId: previewProjectId,
        resultDigestId,
    });

    return (
        <View style={[styles.wrapper, style]} testID={testID}>
            <Button
                label={label}
                href={trialHref}
                onPress={Platform.OS === 'web' ? undefined : () => router.push(trialHref)}
                variant="primary"
                iconName="play"
                style={styles.button}
                textStyle={styles.buttonText}
            />
            <Text style={[styles.finePrint, interRegular]}><Trans id="billing.previewresumetrackingbutton.noChargeTodayCancelBeforeTheTrialEndsAndPay" comment="UI copy in components/billing/PreviewResumeTrackingButton.tsx">
                No charge today. Cancel before the trial ends and pay nothing.
            </Trans></Text>
        </View>
    );
}

const styles = StyleSheet.create({
    wrapper: {
        alignSelf: 'flex-start',
        maxWidth: '100%',
        marginTop: 18,
    },
    button: {
        maxWidth: '100%',
        backgroundColor: colors.action,
        paddingHorizontal: 22,
    },
    buttonText: {
        fontSize: 15,
    },
    finePrint: {
        color: colors.text500,
        fontSize: 12,
        lineHeight: 18,
        marginTop: 10,
    },
});
